import { Component, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { ConfigurationListEntry } from '../configuration-route-configurations/configuration-route-configurations.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-configuration-selector-list',
  templateUrl: './configuration-selector-list.component.html',
  styleUrls: ['./configuration-selector-list.component.scss'],
  standalone: false,
})
export class ConfigurationSelectorListComponent implements OnChanges {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() headerText;
  @Input() buttonText;
  @Input() configurations: ConfigurationListEntry[];
  @Input() isLeftSide: boolean;

  @Output() entryAction = new EventEmitter<ConfigurationListEntry>();

  count = 0;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.configurations) {
      this.count = 0;
      if (changes.configurations.currentValue) {
        this.count = this.configurations.reduce(
          (prev, curr) => prev + curr.configurations.length,
          0
        );
      }
    }
  }

  onConfigurationClicked(entry) {
    this.entryAction.emit(entry);
  }
}
